<template>
    <div class="dashboard__list_trainer_complete_sessions">
        <component-title :size="'large'">Completed sessions</component-title>
        <component-list
            :component-table="DashboardListTrainerTable"
            :component-table-name="'dashboard-trainer-complete'"
            :filters-active="false"
            :filter-search-queryable="true"
            :filter-search-placeholder="'Search session'"
            :get-pagination-getter="'getEbsSessionsCustomCompletePagination'"
            :get-items-getter="'getEbsSessionsCustomCompleteData'"
            :get-items-dispatch="'ebsSessionsGetTrainerComplete'"
            :item-name="['session', 'sessions']"
            :table-preferences-active="true"
        />
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import DashboardListTrainerTable from '@/components/dashboard/list/trainer/DashboardListTrainerTable'
import ComponentTitle from '@/components/default/shared/ComponentTitle'

export default {
  name: 'dashboard-list-trainer-complete-sessions',
  components: { ComponentTitle, ComponentList },
  data () {
    return {
      DashboardListTrainerTable
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlistcompleteitems.scss";
</style>
